export default "__VITE_ASSET__B1Qh4Zar__"